import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionService } from '../encryption/encryption.service';
import { NotificationService } from '../notification/notification.service';
import { HttpService } from '../http/http.service';
import { Config } from 'src/app/app-constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  chatMessages: any = [];
  loggedInUserID: any;
  loggedInUserRole: any;

  private notificationCount = new BehaviorSubject<string>('0');
  notificationCount$ = this.notificationCount.asObservable();

  constructor(
    private router: Router,
    private encryptionService: EncryptionService,
    private notificationService: NotificationService,
    private httpService: HttpService,
    private config: Config
  ) {
    this.loggedInUserID = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
  }
  status: any;
  soundNotification: HTMLAudioElement = new Audio('././assets/mixkit-access-allowed-tone-2869.wav');
  socket: any;

  openWebSocket() {
    this.loggedInUserID = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.status = '';

    // Initialize audio element
    this.soundNotification = new Audio('././assets/mixkit-access-allowed-tone-2869.wav'); // Adjust the path accordingly

    // WebSocket connection
    this.socket = new WebSocket('wss://devhrisapi.phiedge.co.in/socket?userId=' + this.loggedInUserID + '&userRole=' + this.loggedInUserRole);

    this.socket.addEventListener('open', (event: any) => {
      console.log('WebSocket connected');
      this.status = 'WebSocket connected';
    });

    this.socket.addEventListener('message', (event: any) => {
      console.log('WebSocket Message', event);
      this.showCustomNotification(event?.data);
      this.getCountOfUnreadNotification();

      // if (this.router.url == '/home/womens-safety-dashboard') {
      //   setTimeout(() => {
      //     window.location.reload();// Reload the page ignoring the cache
      //   },
      //     1500);
      // } else {
      //   this.router.navigateByUrl('/home/womens-safety-dashboard');
      // }
      this.playSound();
    });

    this.socket.addEventListener('close', (event: any) => {
      this.status = 'WebSocket closed';
    });

    this.socket.addEventListener('error', (event: any) => {
      this.status = 'WebSocket error';
    });
  }

  playSound() {
    // Check if the browser allows audio playback without user interaction
    const playPromise = this.soundNotification.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {})
        .catch(error => {
          // Handle error (e.g., the user didn't interact with the document first)
          console.error(error);
        });
    }
  }
  url: any;
  showCustomNotification(message: any) {
    let notify_data = 'Notification';
    let title = 'Welcome to Phi EDGE-HRMS';
    let options = {
      body: message,
      icon: './assets/icon/phiedge_logo.png',
      badge: './assets/icon/phiedge_logo.png'
    };

    console.log('New message received.', notify_data);
    let notify: Notification = new Notification(title, options);
    // this.getAllNotifiaction();
    notify.onclick = event => {
      event.preventDefault();
      this.url = 'https://devhris.phiedge.co.in/home/hrportal/dwmplus';
      var win = window.open(this.url, '_blank');
      if (win) {
        win.focus();
      }
    };
  }

  getCountOfUnreadNotification() {
    this.httpService.callGetService(this.config.getCountOfUnreadNotification + this.loggedInUserID).subscribe((response: any) => {
      let activeNotificationCount = response?.data ? response?.data : 0;
      activeNotificationCount = activeNotificationCount > 99 ? '99+' : activeNotificationCount.toString();

      this.notificationCount.next(activeNotificationCount);
    });
  }
}
